import React, { useState, useEffect, useCallback } from 'react';
import api from '../../services/api'; // DÜZELTME: axios yerine api servisi kullanıyoruz
import { FaSync, FaEnvelopeOpenText, FaTimes } from 'react-icons/fa';

const UserMailPoolPage = () => {
    const [emails, setEmails] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [lastUpdated, setLastUpdated] = useState(new Date());
    const [selectedMail, setSelectedMail] = useState(null);

    // NOT: getCleanToken fonksiyonuna gerek kalmadı, api servisi hallediyor.

    const fetchEmails = useCallback(async (isAuto = false) => {
        if (!isAuto) setLoading(true);
        try {
            // DÜZELTME: Doğrudan api.get kullanıyoruz.
            // Bu sayede localhost:3000 yerine otomatik olarak backend'e (5000) gider.
            const { data } = await api.get('/mail/messages');
            
            setEmails(data);
            setLastUpdated(new Date());
            setError(null);
        } catch (err) {
            console.error(err);
            // Hata mesajını daha anlaşılır yapalım
            const errMsg = err.response?.data?.message || 'Mailler alınamadı. Sunucuya ulaşılamıyor.';
            setError(errMsg);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchEmails(); 
        const interval = setInterval(() => {
            fetchEmails(true);
        }, 30000); 
        return () => clearInterval(interval);
    }, [fetchEmails]);

    // ... (GERİ KALAN JSX KODLARI AYNEN KALSIN, DEĞİŞİKLİK YOK) ...
    
    return (
        <div className="space-y-6 h-full flex flex-col">
            <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
                <div>
                    <h1 className="text-3xl font-bold text-text-primary flex items-center gap-3">
                        <FaEnvelopeOpenText className="text-primary" />
                        E-Mail Havuzu
                    </h1>
                    <p className="text-text-secondary text-sm mt-1">
                        Ortak hesaba (havuz@payda.web.tr) gelen doğrulama kodları ve bildirimler.
                    </p>
                </div>
                <div className="flex items-center gap-3">
                    <span className="text-xs text-text-secondary hidden md:block">
                        Son güncel: {lastUpdated.toLocaleTimeString()}
                    </span>
                    <button 
                        onClick={() => fetchEmails(false)} 
                        disabled={loading}
                        className="flex items-center gap-2 bg-primary hover:bg-blue-600 text-white px-4 py-2 rounded-lg font-bold transition-all disabled:opacity-50 shadow-lg shadow-primary/20"
                    >
                        <FaSync className={loading ? "animate-spin" : ""} />
                        {loading ? 'Yenileniyor...' : 'Yenile'}
                    </button>
                </div>
            </div>

            {error && (
                <div className="p-4 bg-red-900/20 text-red-400 rounded-lg border border-red-900/50 flex items-center gap-2">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" /></svg>
                    {error}
                </div>
            )}

            <div className="flex-grow bg-surface rounded-xl border border-border overflow-hidden flex flex-col shadow-xl">
                <div className="grid grid-cols-12 bg-gray-800/50 p-3 text-xs font-bold text-text-secondary uppercase border-b border-border">
                    <div className="col-span-3 md:col-span-2">Gönderen</div>
                    <div className="col-span-6 md:col-span-8">Konu</div>
                    <div className="col-span-3 md:col-span-2 text-right">Tarih</div>
                </div>

                <div className="overflow-y-auto custom-scrollbar flex-grow max-h-[600px]">
                    {loading && emails.length === 0 ? (
                        <div className="flex flex-col items-center justify-center h-64 text-text-secondary gap-3">
                            <FaSync className="animate-spin text-3xl opacity-50" />
                            <p>Posta kutusuna bağlanılıyor...</p>
                        </div>
                    ) : emails.length > 0 ? (
                        emails.map((mail) => (
                            <div 
                                key={mail.id} 
                                onClick={() => setSelectedMail(mail)}
                                className="grid grid-cols-12 p-4 border-b border-border hover:bg-white/5 cursor-pointer transition-colors items-center group"
                            >
                                <div className="col-span-3 md:col-span-2 text-sm font-bold text-white truncate pr-2 group-hover:text-primary transition-colors">
                                    {mail.from.replace(/<.*>/, '').trim()}
                                </div>
                                <div className="col-span-6 md:col-span-8">
                                    <p className="text-sm font-semibold text-text-primary truncate">{mail.subject}</p>
                                    <p className="text-xs text-text-secondary truncate opacity-70 mt-0.5">{mail.text.substring(0, 100)}...</p>
                                </div>
                                <div className="col-span-3 md:col-span-2 text-right text-xs text-text-secondary font-mono">
                                    {new Date(mail.date).toLocaleDateString('tr-TR', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' })}
                                </div>
                            </div>
                        ))
                    ) : (
                        <div className="p-10 text-center text-text-secondary flex flex-col items-center">
                            <FaEnvelopeOpenText className="text-4xl mb-3 opacity-20" />
                            <p>Gelen kutusu boş veya mesaj bulunamadı.</p>
                        </div>
                    )}
                </div>
            </div>

            {selectedMail && (
                <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4 backdrop-blur-sm" onClick={() => setSelectedMail(null)}>
                    <div className="bg-surface w-full max-w-4xl h-[80vh] rounded-xl shadow-2xl border border-border flex flex-col overflow-hidden animate-in zoom-in-95 duration-200" onClick={e => e.stopPropagation()}>
                        <div className="p-4 border-b border-border bg-gray-800 flex justify-between items-start">
                            <div>
                                <h2 className="text-xl font-bold text-white mb-1">{selectedMail.subject}</h2>
                                <div className="text-sm text-text-secondary flex gap-2">
                                    <span className="font-bold text-primary">{selectedMail.from}</span>
                                    <span>&bull;</span>
                                    <span>{new Date(selectedMail.date).toLocaleString()}</span>
                                </div>
                            </div>
                            <button onClick={() => setSelectedMail(null)} className="p-2 hover:bg-gray-700 rounded-full text-white transition-colors">
                                <FaTimes size={20} />
                            </button>
                        </div>
                        <div className="flex-grow bg-white overflow-y-auto">
                            {selectedMail.html ? (
                                <iframe 
                                    title="mail-content"
                                    srcDoc={selectedMail.html} 
                                    className="w-full h-full border-none"
                                    sandbox="allow-popups allow-popups-to-escape-sandbox allow-same-origin"
                                />
                            ) : (
                                <div className="p-6 text-black whitespace-pre-wrap font-mono text-sm">
                                    {selectedMail.text}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default UserMailPoolPage;